import 'css-chunksrc/client/pages/projectPage/timeSheetPage/total/styles.scss';export default {
  "total": "_total_nipg0_1",
  "day": "_day_nipg0_8",
  "record": "_record_nipg0_15",
  "hovered": "_hovered_nipg0_29",
  "button": "_button_nipg0_29",
  "pendingValidation": "_pendingValidation_nipg0_30",
  "validated": "_validated_nipg0_34",
  "text": "_text_nipg0_45",
  "deadline": "_deadline_nipg0_51",
  "checkMark": "_checkMark_nipg0_63"
};